import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, ChevronDown, ChevronUp, Send } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HelpPage = () => {
  const navigate = useNavigate();
  const [faq, setFaq] = useState([]);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = async () => {
    try {
      const response = await axios.get(`${API}/faq`);
      setFaq(response.data);
    } catch (error) {
      console.error('Error fetching FAQ:', error);
    }
  };

  const handleSubmit = async () => {
    if (!message.trim()) return;
    try {
      await axios.post(`${API}/support/contact`, { message });
      alert("Message sent! We'll get back to you within 24 hours.");
      setMessage('');
      setShowContact(false);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button onClick={() => navigate('/profile')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#C8A878', padding: '8px' }}>
          <ArrowLeft size={24} />
        </button>
        <h1 className="page-title">Help & Support</h1>
      </div>

      <div style={{ padding: '20px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#C8A878' }}>Frequently Asked Questions</h2>

        {faq.map((item) => (
          <div key={item.id} className="card" style={{ marginBottom: '12px' }} data-testid={`faq-${item.id}`}>
            <button
              onClick={() => setExpandedFaq(expandedFaq === item.id ? null : item.id)}
              style={{
                width: '100%',
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                textAlign: 'left',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                color: '#F1E6D0'
              }}
            >
              <h3 style={{ fontSize: '16px', fontWeight: 'bold', flex: 1 }}>{item.question}</h3>
              {expandedFaq === item.id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {expandedFaq === item.id && (
              <p style={{ marginTop: '12px', fontSize: '14px', color: '#F1E6D0', lineHeight: '1.6' }}>
                {item.answer}
              </p>
            )}
          </div>
        ))}

        <div style={{ marginTop: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#C8A878' }}>Contact Support</h2>

          {!showContact ? (
            <button
              onClick={() => setShowContact(true)}
              className="btn-primary"
              style={{ width: '100%' }}
              data-testid="contact-support-btn"
            >
              Send us a message
            </button>
          ) : (
            <div className="card">
              <textarea
                className="input-field"
                rows="6"
                placeholder="How can we help you?"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                data-testid="contact-message-input"
              />
              <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
                <button
                  onClick={() => setShowContact(false)}
                  className="btn-secondary"
                  style={{ flex: 1 }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="btn-primary"
                  style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                  data-testid="send-message-btn"
                >
                  <Send size={16} />
                  Send
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={{ marginTop: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#C8A878' }}>Safety Guidelines</h2>
          <div className="card">
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'Never share personal information like your home address or financial details',
                'Meet in public places for first encounters',
                'Trust your instincts - if something feels off, it probably is',
                'Use the Block and Report features if someone makes you uncomfortable',
                'Keep your location privacy settings updated',
              ].map((guideline, idx) => (
                <li key={idx} style={{ padding: '8px 0', fontSize: '14px', color: '#F1E6D0' }}>
                  • {guideline}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
